/* eslint-disable promise/param-names */
/**
 * Fuction to wait a time before resolve a promise
 * @param {Number} ms milliseconds
 * @param {Function} callback callback function
 * @param {Boolean} isReject is reject promise
 * @returns return a promise
 */
const wait = (ms = 1000, callback, isReject = false) => {
  if (!isReject)
    return new Promise(resolve => setTimeout(resolve(callback), ms))

  return new Promise((_, reject) => setTimeout(reject(callback), ms))
}
export { wait }
